<div class="inline-block"
      #tooltipHost="appRichTooltip"
     [appRichTooltip]="tooltipTemplate"
     [tooltipContext]="getContext()"
     tooltipAlignment="center">

  <span class="absolute top-0 left-[95%] flex h-4 w-6 items-center justify-center rounded-full text-[9px] font-light"
         [class.bg-amber-600]="!isUndoActive"
         [class.text-white]="!isUndoActive"
         [class.bg-orange-100]="isUndoActive"
         [class.text-amber-600]="isUndoActive"
        >
    @if(totalModified > 0)
    { {{ index }}/{{totalModified}} }
    @else
    { {{ index }} }
  </span>

</div>

<ng-template #tooltipTemplate let-ctx>
  <div class="absolute right-0 -top-5 bg-white rounded-xl shadow-2xl border border-gray-300 min-w-[250px] max-w-[300px] overflow-hidden">
    <div class="p-3 bg-amber-50 border-b border-amber-100">
      <span class="w-1.5 h-1.5 rounded-full bg-amber-400"> </span>      
      <div class="font-light text-xs">
        {{ 'entities.'+ (metaData.EntityName[0].toLowerCase() + metaData.EntityName.slice(1)) +'.propreties.' + (ctx.property[0].toLowerCase() + ctx.property.slice(1)) | translate }}
        - {{ 'modified' | translate }}  <span> <span class="font-semibold">{{ 'At' | translate }}:</span> {{ ctx.entity._modifiedAt | date:'short' }} </span>
      </div>
      <div class="font-light text-xs"> <span><span class="font-semibold">{{ 'By' | translate }}:</span> {{ ctx.entity._modifiedBy }}</span></div>
    </div>
    <div class="p-3 space-y-2 text-xs">
      <div><span class="font-semibold">{{ 'old-value' | translate }} : </span> {{ ctx.oldValue }}</div>
      <div><span class="font-semibold">{{ 'new-value' | translate }} : </span> {{ ctx.newValue }}</div>
    </div>
    <div class="p-2 bg-gray-50 border-t border-gray-100 flex justify-end gap-2">
      <button (click)="ctx.toggleUndo(ctx.property)"
              class="px-3 py-1 text-xs rounded-md border border-amber-700"
              [class.bg-amber-600]="!ctx.isUndoActive"
              [class.text-white]="!ctx.isUndoActive"
              [class.bg-orange-100]="ctx.isUndoActive"
              [class.text-amber-600]="ctx.isUndoActive">
        {{ ctx.isUndoActive ? ('Redo' | translate) : ('Undo' | translate) }}
      </button>
    </div>
  </div>
</ng-template>
